/**
 * Home Hero — respect reduced motion (pause background video).
 */
export function initHomeHero() {
	const blocks = document.querySelectorAll('.block-home-hero');
	if (!blocks.length) {
		return;
	}

	const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	if (!prefersReducedMotion) {
		return;
	}

	blocks.forEach((block) => {
		block.querySelectorAll('.home-hero__video').forEach((video) => {
			video.pause();
			video.removeAttribute('autoplay');
		});
	});
}
